import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { MDBSelect, MDBIcon } from 'mdb-react-ui-kit';
export default memo(({ data, isConnectable }) => {
  function PopupCall() {
    console.log("topUp in PopupCall:", data.Popup);
    data.Popup();
  }
  return (
    <>
      <div className="huntNodeHeader">{data.label}<MDBIcon fas icon="times" color="light" className="cursor-pointer" /></div>
      <div className="nodeBody">
        <div className="nodeSelectLinkIcon">
          <select name="cars" id="cars" defaultValue="none" className="form-control form-select     "
            onChange={(event) => {
              if (event.target.value === "Select") {
                PopupCall();
              }
            }}>
            <option value="none" selected>Holiday AA</option>
            <option value="Select">Choose Holiday AA...</option>
            <option value="volvo" >San Jose</option>
            <option value="saab">Grants Pass</option>
            <option value="mercedes">Klamath Falls</option>
          </select>
          <MDBIcon fas icon="external-link-square-alt" className="nodeLinkIcon" />
        </div>
        <div className="nodeAudioControls">
          <audio src="#" controls></audio>
        </div>
        <div className="d-flex align-items-center justify-content-between px-2">
          <small>Default</small>
          <small className="text-primary">
            <a href="" className="text-small">
              Edit
            </a>
          </small>
        </div>
        <button className="btn-primary nodeButton"><MDBIcon fas icon="plus" color="white" className="me-1" />Add Option</button>
      </div>
      <Handle
        type="target"
        position={Position.Left}
        id="bt"
        isConnectable={isConnectable}
      ></Handle>
      <Handle
        type="source"
        position={Position.Right}
        id="as"
        style={{
          top: 185,
          right: -7,
          background: "#fff",
          height: 10,
          width: 10,
          border: "2px solid #288cd4"
        }}
      >
        <div className="handletext">Timeout</div>
      </Handle>
      <Handle
        type="source"
        position={Position.Right}
        id="bs"
        style={{
          top: 210,
          right: -7,
          background: "#fff",
          height: 10,
          width: 10,
          border: "2px solid #288cd4"
        }}
      >
        <select className="handleselect" name="cars" id="cars">
          <option value="volvo" selected>
            0
          </option>
          <option value="saab">1</option>
          <option value="mercedes">2</option>
          <option value="saab">3</option>
          <option value="mercedes">4</option>
          <option value="saab">5</option>
          <option value="mercedes">6</option>
          <option value="saab">7</option>
          <option value="mercedes">8</option>
          <option value="saab">9</option>
          <option value="mercedes">*</option>
          <option value="mercedes">#</option>
        </select>
      </Handle>
    </>
  );
});
